/**
 * Point d'entrée de l'application Widgets Brydge
 *
 * Détermine le mode de rendu selon le contexte :
 * - Mode iframe : WidgetRouter pour les widgets intégrés
 * - Mode développement : App pour les tests locaux
 *
 * @module index
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import WidgetRouter from './WidgetRouter';

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  // Détermination du contexte d'exécution (iframe ou développement)
  const isIframe = window.location.pathname !== '/';

  root.render(
      <React.StrictMode>
        {isIframe ? <WidgetRouter /> : <App />}
      </React.StrictMode>,
  );
}
